<template>
  <div class="wonderful-case">
    <div class="case-title" v-if="showOther">{{ langData.title }}</div>
    <div
      class="case-content"
      :class="{ other: showOther }"
      v-if="list.length"
      :key="Math.random()"
    >
      <div
        class="case-item"
        v-for="item in list"
        :key="item.id"
        @click="goDetail(item)"
      >
        <div class="item-img">
          <img :src="item.BannerImg" />
        </div>
        <div class="item-text">
          <span
            >{{ langData.model }}：{{
              langEn ? item.En_Brand_Name : item.Brand_Name
            }}</span
          >
          <span
            >{{ langData.product }}：{{
              langEn ? item.ProductENName : item.ProductName
            }}</span
          >
        </div>
      </div>
      <div class="case-item empty"></div>
      <div class="case-item empty"></div>
      <div
        class="case-arrow display-flex left"
        v-if="showOther"
        @click="arrowClick(searchObj.Pageindex--)"
      >
        <img :src="arrow" />
      </div>
      <div
        class="case-arrow display-flex right"
        v-if="showOther"
        @click="arrowClick(searchObj.Pageindex++)"
      >
        <img :src="arrow" />
      </div>
    </div>
  </div>
</template>

<script>
import arrow from "@/assets/img/brand/arrow.png";
export default {
  name: "WonderfulCase",
  props: {
    caseList: {
      type: Array,
      default: null,
    },
    showOther: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      arrow,
      list: [],
      searchObj: {
        Pageindex: 1,
        Pagenum: 3,
        ProductId: 62,
      },
      pageTotal: 0,
    };
  },
  computed: {
    langEn() {
      return this.$store.state.dynamic.lang === "en";
    },
    langData() {
      return this.$t("WonderfulCase");
    },
  },
  methods: {
    refreshList(val) {
      this.list = JSON.parse(JSON.stringify(val));
    },
    goDetail(item) {
      this.$router.push({
        path: `/CaseDetail/${item.Id}`,
      });
    },
    arrowClick(type) {
      if (
        this.searchObj.Pageindex === 0 ||
        this.searchObj.Pageindex === this.pageTotal + 1
      ) {
        this.searchObj.Pageindex =
          this.searchObj.Pageindex === 0 ? 1 : this.pageTotal;
        return;
      }
      this.getCaseList();
    },
    getCaseList(init) {
      const _this = this;
      this.$httpGet("/GetCase", this.searchObj).then((res) => {
        if (!res) return;
        // 组装案例列表
        _this.list = res.rows;
        if (!init) return;
        this.pageTotal = Math.ceil(res.total / _this.searchObj.Pagenum);
      });
    },
  },
  created() {
    if (!this.showOther) {
      this.list = JSON.parse(JSON.stringify(this.caseList));
      return;
    }
    this.getCaseList(true);
  },
};
</script>

<style>
/*精彩案例*/
.wonderful-case {
  overflow: hidden;
  width: 100%;
  background-color: #000;
}

.wonderful-case .case-title {
  text-align: center;
  height: 42px;
  line-height: 42px;
  font-size: 44px;
  font-family: PingFang;
  font-weight: 800;
  color: #ffffff;
  margin: 109px 0 86px 0;
}

.wonderful-case .case-content {
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  /* padding: 0 360px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
}

.wonderful-case .case-content.other .case-item {
  margin-top: 0 !important;
}

.wonderful-case .case-content .case-item {
  width: 390px;
  height: 339px;
  background: #332f30;
  margin-top: 27px;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
}

.wonderful-case .case-content .case-item.empty {
  height: 0;
  margin: 0;
}

.wonderful-case .case-content .case-item:nth-child(-n + 3) {
  margin-top: 50px;
}

.wonderful-case .case-content.other .case-item:hover::after {
  display: none;
}

.wonderful-case .case-content.other .case-item::after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
}

.wonderful-case .case-content .case-item .item-img {
  width: 100%;
  height: 234px;
}

.wonderful-case .case-content .case-item .item-img img {
  width: 100%;
  height: 100%;
  background-size: cover;
}

.wonderful-case .case-content .case-item .item-text {
  width: 100%;
  height: 105px;
  box-sizing: border-box;
  padding: 25px 19px;
}

.wonderful-case .case-content .case-item .item-text span {
  display: block;
  height: 18px;
  width: 100%;
  line-height: 18px;
  font-size: 18px;
  font-family: PingFang;
  font-weight: 500;
  color: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wonderful-case .case-content .case-item .item-text span:last-child {
  padding-top: 14px;
}

.wonderful-case .case-content .case-arrow {
  position: absolute;
  left: -54px;
  top: 50%;
  margin-top: -18px;
  width: 28px;
  height: 36px;
  line-height: 36px;
  color: #fff;
  cursor: pointer;
  background-color: rgba(230, 26, 15, 0.4);
  z-index: 99;
}

.wonderful-case .case-content .case-arrow.right {
  left: initial;
  right: -54px;
}

.wonderful-case .case-content .case-arrow.left {
  transform: rotate(180deg);
}

@media screen and (max-width: 1200px) {
  .wonderful-case .case-content .case-arrow.left {
    left: 26px !important;
  }

  .wonderful-case .case-content .case-arrow.right {
    right: 26px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/WonderfulCase.vue